import { Grid, Typography, Box, Paper, useTheme } from '@mui/material';

export default function ClientInfo(props) {
  const theme = useTheme();
  return (
    <>
      <Grid
        item
        xs={12}
        lg={5.7}
        xl={5.7}
        sx={{
          backgroundColor: '#118553',
          color: '#FFFFFF',
          width: '50%',
          [theme.breakpoints.down('lg')]: {
            mb: 5,
          },
          [theme.breakpoints.up('lg')]: {
            mr: 5,
          },
        }}
        component={Paper}
      >
        <Box textAlign="left" sx={{ py: 4, px: 4 }}>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Imię: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.name}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Nazwisko: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.surname}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">PESEL: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.pesel}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Numer ARIMR: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.arimr}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">NIP: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.nip === '0' ? '-' : props.data?.nip}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Adres: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.address}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Telefon: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.phoneNumber}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Adres mailowy: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.email}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Numer zapytania: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.loanId}
            </Typography>
          </Grid>
        </Box>
      </Grid>
    </>
  );
}
